import React from 'react';
import * as yup from 'yup';
import { FormProvider } from 'react-hook-form';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Name } from '../../fields/Name/Name';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Email } from '../../fields/Email/Email';
import { Address } from '../../fields/Address/Address';
import { DraftAccountDTO, FORM_WIDTH } from '../../AccountOpening.meta';
import { validation } from './PersonalInfo.meta';
import { Footer } from '../../components/Footer/Footer';
import { DateOfBirth } from '../../fields/DateOfBirth/DateOfBirth';
import { Ssn } from '../../fields/Ssn/Ssn';
import { Phone } from '../../fields/Phone/Phone';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useStepForm } from '../../hooks/useStepForm';
import { StepContent } from '../../components/StepContent/StepContent';
import { StepCard } from '../../components/StepCard/StepCard';

interface Props {
  draftAccount: DraftAccountDTO;
  fieldName: 'primaryApplicant' | 'secondApplicant';
  title?: string;
  onSuccess(): void;
  onPrevious?(): void;
}

export const PersonalInfo: React.FC<Props> = ({
  draftAccount,
  title,
  fieldName,
  onSuccess,
  onPrevious,
}) => {
  const { formBag, saveDraftMutation, onSubmit } = useStepForm({
    draftAccount,
    onSuccess,
    validation: yup.object().shape({
      [fieldName]: validation,
    }),
  });

  return (
    <FormProvider {...formBag}>
      <form onSubmit={formBag.handleSubmit(onSubmit)}>
        <StepContent>
          <StepCard maxWidth={FORM_WIDTH}>
            <Text fontSize="h5" fontWeight={600}>
              {title || 'Your information'}
            </Text>

            {saveDraftMutation.error && (
              <Alert message={saveDraftMutation.error.message} variant="error" mt="32" />
            )}

            <Name fieldName={fieldName} draftAccount={draftAccount} mt="32" />

            <Grid>
              <Row mt="32">
                <Column width={6}>
                  <DateOfBirth fieldName={`${fieldName}.dob`} draftAccount={draftAccount} />
                </Column>

                <Column width={6}>
                  <Ssn fieldName={`${fieldName}.ssn`} draftAccount={draftAccount} />
                </Column>
              </Row>
            </Grid>

            <Phone fieldName={`${fieldName}.phoneNumber`} draftAccount={draftAccount} mt="32" />

            <Email fieldName={`${fieldName}.email`} draftAccount={draftAccount} mt="32" />

            <Address fieldName={fieldName} draftAccount={draftAccount} mt="32" />
          </StepCard>
        </StepContent>

        <Footer isLoading={saveDraftMutation.isLoading} onPrevious={onPrevious} />
      </form>
    </FormProvider>
  );
};
